export default { sha: 'afa8d9e19851b69cccd592663632c4b8ec2d39b7', buildNumber: 'undefined' }
